<template>
  <div class="file-component" v-invalid="validation.is_valid">
    <div class="field" :class="getFieldClass(field.layout.layout_type)">
      <div class="is-bottom-paddingless" :class="getLabelClass(field.layout.layout_type)">
        <label
          class="label"
          v-if="field.label"
          :for="field.id">
          <span
            style="display:list-item; list-style-position: inside"
            :style="{'list-style-type': listMarker}">
            {{ field.label }}
          </span>
        </label>
      </div>
      <div
        class="control is-bottom-paddingless"
        :class="getControlClass(field.layout.layout_type)">
        <div>
          <label>
            <input
              :value="changeVal"
              :multiple="true"
              class="file-input"
              :class="getInputClass(validation.is_valid)"
              type="file"
              @change="onChangeHandler($event, field)"
              :accept="field.properties.accept_file_type"
              :id="field.id"
              :name="field.id"
              :disabled="field.properties.input_readonly">
            <span class="button file-cta is-primary is-outlined">
              <span class="file-icon">
                <i class="mdi mdi-upload"></i>
              </span>
              <span class="" v-translate>
                Add file(s)
              </span>
            </span>
          </label>
          <template v-if="fileNames.length">
            <span
              v-for="(name, index) in fileNames"
              :key="index"
              class="tag is-medium file-pill">
              <span>{{ name }}</span>
              <button class="delete is-small" @click="removeFile(index)"></button>
            </span>
          </template>
        </div>
        <p
          class="help is-danger"
          v-if="!validation.is_valid">
          {{ validation.message }}
        </p>
        <p
          class="help"
          v-if="field.properties.help_text"
          v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'

  export default {
    name: 'multiple-file-component',
    data () {
      return {
        changeVal: ''
      }
    },
    props: {
      field: {
        type: FormField
      },
      listMarker: {
        type: String,
        default: 'none'
      },
      formData: {
        type: FormData
      }
    },
    computed: {
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      },
      fileNames () {
        let files = this.formData.fields[this.field.id].value
        if (typeof files === 'string') {
          this.clearFormDataFieldValues()
          files = this.formData.fields[this.field.id].value
        }
        return files ? files.map(file => file.name) : []
      }
    },
    methods: {
      ...mapActions([
        'errorMessage'
      ]),
      onChangeHandler (event, field) {
        this.changeVal = ''
        this.formData.inputOnChange(field)
        this.setFiles(event)
      },
      setFiles (event) {
        let files = event.target.files
        if (files.length > 0) {
          this.removeValidation()
          for (let key in files) {
            if (typeof files[key] === 'object') {
              if (files[key].size) {
                this.addFile(files[key])
              } else {
                let translate = this.$gettext('File %{ name } is empty and will not be uploaded.')
                this.errorMessage(this.$gettextInterpolate(translate, { name: files[key].name }))
              }
            }
          }
        }
      },
      addFile (file) {
        let value = this.formData.fields[this.field.id].value || []
        if (!this.fileNames.includes(file.name)) {
          value.push(file)
        }
        this.formData.fields[this.field.id].value = value
      },
      removeFile (index) {
        this.fileNames.splice(index, 1)
        this.formData.fields[this.field.id].value.splice(index, 1)
      },
      removeValidation () {
        this.validation.is_valid = true
      },
      getFieldClass (layoutType) {
        return {
          'columns is-multiline is-mobile': layoutType === 'horizontal'
        }
      },
      getLabelClass (layoutType) {
        return {
          'column is-12-mobile is-3-desktop': layoutType === 'horizontal'
        }
      },
      getControlClass (layoutType) {
        return {
          'column is-12-mobile is-9-desktop': layoutType === 'horizontal'
        }
      },
      getInputClass (isValid) {
        return {
          'is-danger': !isValid
        }
      },
      clearFormDataFieldValues () {
        this.formData.fields[this.field.id].value = []
      }
    },
    created () {
      this.clearFormDataFieldValues()
    }
  }
</script>

<style lang="sass" scoped>
  .file-name
    display: inline-block

  .file-component
    margin-bottom: 1.53rem

  .file-input
    height: 0em
    left: 0
    outline: none
    position: absolute
    top: 0
    width: 0.01em
    display: none

  .file-pill
    margin-left: 1rem
    margin-bottom: 1rem
    border: 1px solid gray
    color: gray
    span
      display: inline-block
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      max-width: 100px
</style>
